// External packages
import { Container, createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

// Components
import App from './App';

// Styles
import './index.css';

createRoot(document.getElementById('root') as Container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
